import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_my_einvoice_individual_pool_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  generic_doc_line_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  pin_code: fromDatatype.VarcharDatatypeInterface;
  pin_type: fromDatatype.VarcharDatatypeInterface;
  pin_hash: fromDatatype.VarcharDatatypeInterface;
  pin_algorithm: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delivery_entity_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_shipping_entity_guid: fromDatatype.GuidDataFieldInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  einvoice_supplier_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_delivery_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  validation_msg: fromDatatype.TextDatatypeInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_json: any;
  doc_reference: fromDatatype.VarcharDatatypeInterface;
  billing_json: any;
  delivery_entity_json: any;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  original_einvoice_ref_no: fromDatatype.VarcharDatatypeInterface;
  queue_status: fromDatatype.VarcharDatatypeInterface;
  einvoice_buyer_entity_hdr_json: any;
  einvoice_supplier_entity_hdr_json: any;
  buyer_address_json: any;
  supplier_address_json: any;
  einvoice_submission_type: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_my_einvoice_individual_pool_doc_hdr_RowClass
  implements bl_fi_my_einvoice_individual_pool_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  generic_doc_line_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  pin_code: fromDatatype.VarcharDatatypeInterface;
  pin_type: fromDatatype.VarcharDatatypeInterface;
  pin_hash: fromDatatype.VarcharDatatypeInterface;
  pin_algorithm: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delivery_entity_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_shipping_entity_guid: fromDatatype.GuidDataFieldInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  einvoice_supplier_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_delivery_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  validation_msg: fromDatatype.TextDatatypeInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_json: any;
  doc_reference: fromDatatype.VarcharDatatypeInterface;
  billing_json: any;
  delivery_entity_json: any;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  original_einvoice_ref_no: fromDatatype.VarcharDatatypeInterface;
  queue_status: fromDatatype.VarcharDatatypeInterface;
  einvoice_buyer_entity_hdr_json: any;
  einvoice_supplier_entity_hdr_json: any;
  buyer_address_json: any;
  supplier_address_json: any;
  einvoice_submission_type: fromDatatype.VarcharDatatypeInterface;
}
